/* eslint-disable camelcase */
import { v4 as uuidV4 } from 'uuid';
import { doorClient, ImResponse } from '.';
import { pingpongBodyTransfer } from './pay';

export interface GetCoinsOrderListParams {
  pageNo?: number;
  pageSize?: number;
}

export interface CoinsOrder {
  amount: number;
  /**
   * 货币
   */
  currency: General.Currency;
  orderCode: string;
  /**
   * 1 待支付 2已完成 3 已取消 4 已失效
   */
  orderStatus: 1 | 2 | 3 | 4;
  /**
   * 充值的额度
   */
  virtualAssetsBalance: string;
  updateTimeStamp: Java.Timestamp;
}

interface BasicRespWithPageInfo {
  pageInfo: {
    pageSize: number;
    pageNo: number;
    hasNext: boolean;
    total: number;
  };
}

export interface GetCoinsOrderListResp extends BasicRespWithPageInfo {
  data: CoinsOrder[];
}

export const getCoinsOrderList = (params: GetCoinsOrderListParams) => {
  return doorClient.get<ImResponse<GetCoinsOrderListResp>>('/pay/virtual_assets/order/page', {
    params,
  });
};

export interface CalCoinsPaymentPirceResp {
  price: number;
  currency: General.Currency;
}
export const calCoinsPaymentPirce = (params: {
  currency: General.Currency;
  /**
   * 卡券数
   */
  virtualAssistantsNumber: number;
}) => {
  return doorClient.get<ImResponse<CalCoinsPaymentPirceResp[]>>('/pay/virtual_assets/calculate', {
    params,
  });
};

export interface CreateCoinsOrderBody {
  balance: number;
  currency: General.Currency;
  payType: Pay.PayType;
  /**
   * 适配后端 typo @张玉喜
   */
  accId: string;
  idempotent: string;
  language: General.SystemLanguage;
}
export const createCoinsOrder = (body: Omit<CreateCoinsOrderBody, 'idempotent'>) => {
  const idempotent = uuidV4().replaceAll('-', '');
  return doorClient.post<ImResponse<Pay.PayConfig>>('/pay/virtual_assets/create/order', {
    ...pingpongBodyTransfer(body),
    idempotent,
  });
};
export const payWithOrderCode = (body: { orderCode: string; language: General.SystemLanguage }) => {
  const idempotent = uuidV4().replaceAll('-', '');
  return doorClient.post<ImResponse<Pay.PayConfig>>('/pay/virtual_assets/order/pay', {
    ...pingpongBodyTransfer(body),
    idempotent,
  });
};
